import { createUseStyles } from 'react-jss';

const styles = {
  warningContent: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  warningText: {
    fontSize: '1.8rem',
    lineHeight: '2.4rem',
    maxWidth: '23.8rem',
    textAlign: 'center',
    marginTop: '3.5rem',
    marginBottom: '3rem',
    textTransform: 'none',
    letterSpacing: '0.02em',
  },
  demoButtons: { display: 'flex', alignItems: 'center' },
  arrow: { margin: '0 1.6rem' },
  cancelWarningModalBtn: {
    margin: '3rem 0',
    padding: '0rem 5rem',
  },
  buttonsWrapper: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  actionButton: {
    marginLeft: '2rem',
    padding: '0rem 2rem',
  },
};

const createStyles = createUseStyles(styles);
export { createStyles };
